export default __webpack_public_path__ + "static/media/63.d756d5a9.jpeg";